import { Injectable } from '@angular/core';
import { EmailEventRequest } from '../models/request/email-event-request';
import { Observable } from 'rxjs';
import { RestResult } from '../models/response/rest-result';
import { Path } from '../common/path';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { EmailEventWrapper } from '../models/response/email-event-wrapper';
import { SearchRequest } from '../models/request/search-request';
import { EmailEventGroupRequest } from '../models/request/email-event-group-request';

@Injectable()
export class EmailEventService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) { }

  create(request: EmailEventRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }


  update(request: EmailEventRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  getOne(emailEventId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT +
      Path.EMAIL_EVENT_ID.replace(':emailEventId', emailEventId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT +
      Path.SEARCH, request,
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  remove(emailEventId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT +
      Path.EMAIL_EVENT_ID.replace(':emailEventId', emailEventId.toString()),
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError),
    );
  }

  assignGroup(request: EmailEventGroupRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT + Path.ASSIGN, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  unassignGroup(request: EmailEventGroupRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.EMAIL_EVENT + Path.UNASSIGN, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }
}
